import React, { useEffect, useState } from "react";
import { Col, Carousel, Badge } from "react-bootstrap";
import { Image } from "cloudinary-react";
import { FaTag } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./styles.css";

const ProductCard = ({ product, menu }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setCurrentIndex(selectedIndex);
  };

  console.log("productcard_", product);

  // Define chip colors
  const CHIP_COLORS = [
    { bg: "#007bff", text: "#fff" }, // Blue
    { bg: "#28a745", text: "#fff" }, // Green
    { bg: "#dc3545", text: "#fff" }, // Red
    { bg: "#ffc107", text: "#000" }, // Yellow
    { bg: "#17a2b8", text: "#fff" }, // Cyan
    { bg: "#6610f2", text: "#fff" }, // Purple
    { bg: "#e83e8c", text: "#fff" }, // Pink
    { bg: "#fd7e14", text: "#fff" }, // Orange
  ];

  return (
    <Col
      key={product.id}
      className="mb-4"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        // boxShadow: "0px 4px 15px 5px rgba(0, 0, 0, 0.1)",
        // backgroundColor: "#f5f5f5",
        borderRadius: "12px",
        position: "relative",
      }}
    >
      {/* Discount Badge */}
      {!!product?.capacity[currentIndex]?.details[0]?.discount && (
        <span
          className="discount-badge"
          style={{
            backgroundColor: "black",
            color: "white",
            fontSize: "12px",
            padding: "7px 10px",
            borderRadius: "12px",
            position: "absolute",
            right: "8px",
            top: "8px",
            zIndex: 2,
            fontWeight: 700,
          }}
        >
          {/* <FaTag />{" "} */}
          {(
            (product.capacity[currentIndex].details[0].discount /
              product.capacity[currentIndex].details[0].price) *
            100
          ).toFixed(2)}
          % OFF
        </span>
      )}
      <div
        className="product-card"
        style={{ padding: "10px", position: "relative" }}
      >
        {/* Carousel Without Default Indicators */}
        <Carousel
          controls={false}
          interval={null}
          className="custom-carousel"
          activeIndex={currentIndex}
          onSelect={handleSelect}
          indicators={false} // Removes default indicators (dots)
        >
          {product.capacity[currentIndex].details.map((detail, index) =>
            detail.images.map((image, index) => (
              <Carousel.Item key={index}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "350px",
                    width: "100%",
                  }}
                >
                  <Image
                    style={{
                      maxWidth: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                    cloudName="dljielsye"
                    publicId={image.url} // Show first image of each variant
                    alt={`Product Image ${index + 1}`}
                  />
                </div>
              </Carousel.Item>
            ))
          )}
        </Carousel>

        {/* Custom Dots Below Carousel */}
        {/* <div className="custom-indicators">
          {product.capacity[currentIndex].details.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentIndex ? "active" : ""}`}
              onClick={() => setCurrentIndex(index)}
            ></span>
          ))}
        </div> */}

        {/* Product Name & Price (Changes with Image) */}
        <div
          className="card-detail pt-2"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "18px",
            }}
          >
            <h3 style={{ fontSize: "20px", padding: 0, margin: 0 }}>
              {product.productName}
            </h3>
            <span
              className="item-price"
              style={{
                fontWeight: 700,
                fontSize: "28px",
                color: "#0d6efd",
                padding: "0px",
                margin: "0px",
              }}
            >
              $
              {product.capacity[currentIndex].details[0].price -
                product.capacity[currentIndex].details[0].discount}
            </span>
          </div>
          {/* cut price */}
          {!!product.capacity[currentIndex].details[0].discount && (
            <span
              className="item-price"
              style={{
                fontWeight: 500,
                fontSize: "20px",
                color: "#9ca0a4",
                textDecoration: "line-through",
                position: "relative",
                bottom: "-15px",
              }}
            >
              ${product.capacity[currentIndex].details[0].price}
            </span>
          )}
        </div>

        {/* Add to Cart Button */}
        {/* <div className="cart-concern position-absolute">
          <div className="cart-button d-flex">
            <Link
              to={`/product/${product._id}?`}
              className="btn btn-medium btn-black"
              style={{
                backgroundColor: "black",
                color: "white",
                border: "1px solid black",
                paddingLeft: "2rem",
                paddingRight: "2rem",
                textAlign: "center",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#514f4f";
                e.target.style.color = "white";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "black";
                e.target.style.color = "white";
              }}
            >
              Shop Now
            </Link>
          </div>
        </div> */}
      </div>
      {/* Bottom Container */}
      <div
        style={{
          // backgroundColor: "#f5f5f5",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "15px",
          borderBottomLeftRadius: "12px",
          borderBottomRightRadius: "12px",
        }}
      >
        {/* Carrier Compatibility Chips */}
        <div
          className="d-flex flex-wrap justify-content-center gap-1"
          style={{
            padding: "7px 0",
          }}
        >
          {product.carrierComp &&
            product.carrierComp.map((carrier, index) => {
              const randomColor =
                CHIP_COLORS[Math.floor(Math.random() * CHIP_COLORS.length)];

              return (
                <Badge
                  key={index}
                  pill
                  bg="error"
                  className="chip"
                  style={{
                    backgroundColor: randomColor.bg,
                    color: randomColor.text,
                    padding: "4px 8px",
                    fontSize: "15px",
                    fontWeight: "500",
                    borderRadius: "20px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  {carrier}
                </Badge>
              );
            })}
        </div>

        {/* Stock Warning */}
        {product?.capacity[currentIndex]?.details[0]?.quantity < 10 && (
          <span
            style={{
              color: "red",
              fontWeight: "600",
              fontSize: "0.95rem",
              marginBottom: "8px",
            }}
          >
            {product?.capacity[currentIndex]?.details[0]?.quantity} item
            {product?.capacity[currentIndex]?.details[0]?.quantity > 1
              ? "s are"
              : " is"}{" "}
            left in stock
          </span>
        )}

        {/* Shop Now Button */}
        <Link
          to={`/product/${product._id}?`}
          className="btn btn-medium"
          style={{
            backgroundColor: "#000",
            color: "white",
            border: "1px solid black",
            padding: "10px 25px",
            fontSize: "1rem",
            fontWeight: "600",
            borderRadius: "6px",
            transition: "background 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#444";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "black";
          }}
        >
          Shop Now
        </Link>
      </div>
    </Col>
  );
};

export default ProductCard;
